import { render, staticRenderFns } from "./pachieve.vue?vue&type=template&id=4cf7d245&scoped=true&"
import script from "./pachieve.vue?vue&type=script&lang=js&"
export * from "./pachieve.vue?vue&type=script&lang=js&"
import style0 from "./pachieve.vue?vue&type=style&index=0&id=4cf7d245&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf7d245",
  null
  
)

export default component.exports